import React from "react";

function Umbrella({color}) {
  return (
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 145 145"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="72.5" cy="72.5" r="72.5" fill="white" />
      <g clipPath="url(#clip0_814_4220)">
        <path
          d="M116.955 76.1084C112.486 54.6982 95.3296 41.8333 77.0015 39.8383V37.0266C77.0015 34.2463 74.7671 32 72.0015 32C69.2358 32 67.0015 34.2463 67.0015 37.0266V39.8383C48.6109 41.8333 31.6109 54.6982 27.0484 76.1084C26.7046 77.6949 28.3765 79.4542 29.9702 77.8991C38.0952 69.2596 46.7984 69.668 54.7515 83.7111C55.5796 85.2034 57.0796 85.062 57.8296 83.7111C60.9859 78.1504 64.8452 72.2128 72.0015 72.2128C81.1421 72.2128 85.7827 83.0199 86.1734 83.7111C86.9234 85.062 88.4233 85.2034 89.2515 83.7111C97.2202 69.6523 105.986 69.3539 114.033 77.8991C115.642 79.4699 117.298 77.6949 116.955 76.1084ZM67.0015 79.3914V99.859C67.0015 101.241 65.8765 102.372 64.5015 102.372C63.2827 102.372 62.439 101.54 62.1421 100.692C61.2202 98.0683 58.3765 96.7017 55.7671 97.6285C53.1577 98.5553 51.7984 101.43 52.7202 104.037C54.4702 109.048 59.2202 112.41 64.5015 112.41C71.3921 112.41 77.0015 106.771 77.0015 99.8433V79.3757C75.5796 78.1347 73.9077 77.2394 72.0015 77.2394C70.0796 77.2551 68.5015 77.9933 67.0015 79.3914Z"
          fill={color}
        />
      </g>
      <defs>
        <clipPath id="clip0_814_4220">
          <rect
            width="90"
            height="80.4255"
            fill="white"
            transform="translate(27 32)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}



export default Umbrella;
